
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ClassMetadata, GridMetadata } from "@tylertech/tyler-api-types";

/**
 * MetadataExampleService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class MetadataExampleService<TEntityType1 = unknown, TEntityType2 = unknown> {
    private readonly $apiService = inject(ApiService);
    
    GetEmployeeData(employeeId: string): Promise<TEntityType1> {
        return this.$apiService.sendAuth("IMetadataExampleService/GetEmployeeData", employeeId);
    }
    GetEmployeeMetadata(): Promise<ClassMetadata> {
        return this.$apiService.sendAuth("IMetadataExampleService/GetEmployeeMetadata");
    }
    GetEmployeePositionMetadata(): Promise<GridMetadata> {
        return this.$apiService.sendAuth("IMetadataExampleService/GetEmployeePositionMetadata");
    }
    GetMetadataExampleClass(employeeId: string): Promise<TEntityType2> {
        return this.$apiService.sendAuth("IMetadataExampleService/GetMetadataExampleClass", employeeId);
    }
}
